import type { Easing, Variants } from 'motion/react';

/** Animation easing: ease-out-quint for smooth deceleration */
const EASE_OUT_QUINT: Easing = [0.23, 1, 0.32, 1];

/**
 * The peek sheet's chip look, shared by every chip in the collapsed row.
 *
 * Lives here rather than inline in `ChipButton` because the row is no longer
 * only suggestion chips — the capability-signalling verb starters sit in the
 * same 44px strip and have to read as the same control. Two copies of these
 * classes would drift the moment either is touched.
 *
 * Pair with `size="xs"` and `variant="ghost"` on the design-system `Button`,
 * an icon in `text-text-secondary`, and `chipVariants` for the entrance.
 */
export const CHIP_SHELL_CLASS = 'select-none transition-all duration-200';

/** Hover lift and press response. Omitted while a chip is loading. */
export const CHIP_INTERACTIVE_CLASS = 'hover:shadow-sm active:scale-[0.97]';

/** Staggered animation for chips */
export const chipVariants: Variants = {
  hidden: { opacity: 0, scale: 0.8, y: 8 },
  visible: (i: number) => ({
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      delay: i * 0.05,
      duration: 0.25,
      ease: EASE_OUT_QUINT,
    },
  }),
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: { duration: 0.2, ease: [0.55, 0.055, 0.675, 0.19] },
  },
};
